
export namespace Pagination {
  export var defaultProps = {current: 1, pageSize: 100, total: 0, pageSizeOptions: ["10", "50", "100"]};
}
